import { Module } from 'vuex';
import { URLState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { URL_ACTIONS } from './url.actions';
import { URL_GETTERS } from './url.getters';
import { URL_MUTATIONS } from './url.mutations';
import { getInitialUrlState } from './url.state';

export const URL_MODULE: Module<URLState, RootStoreState> = {
  namespaced: true,
  actions: URL_ACTIONS,
  mutations: URL_MUTATIONS,
  getters: URL_GETTERS,
  state: getInitialUrlState()
};
